import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import { api } from '@bilibili-maoer/web-utils';
import { getFetch } from '../../utils/fetcher.js';

var EWxScene;

(function (EWxScene) {
  EWxScene[EWxScene["SubscriptionAccount"] = 1] = "SubscriptionAccount";
  EWxScene[EWxScene["ServiceAccount"] = 2] = "ServiceAccount";
})(EWxScene || (EWxScene = {}));

var getWeChatToken = function getWeChatToken(scene) {
  var _context;

  return getFetch({
    url: _concatInstanceProperty(_context = "".concat(api.MISSEVAN_API_PREFIX_URL, "/mobileWeb/gettoken?scene=")).call(_context, scene)
  });
};

export { EWxScene, getWeChatToken };
